import React, { useContext, useEffect } from 'react';
import { graphql } from 'gatsby';

import SEO from '../../components/SEO';
import ProductPage from './ProductPage';

import { StoreContext } from '../../context/store-context';
import { getMetafield } from '../../utils/helpers';

export default function Product({
	location,
	pageContext: {
		page,
		allBaseColours,
		shadeShotsProducts,
		isPermanentColour,
		rating,
		sellingPlanGroup,
		MiracleSystemSellingPlanGroup,
		productsCustomerLove,
		allSellingPlanGroups,
	},
	data: { product = {}, collections = [] },
}) {
	const { allProducts, cart } = useContext(StoreContext);
	collections = collections.nodes.map((node) => ({
		title: node.title.toLowerCase(),
		handle: node.handle,
		products: node.products,
	}));
	const productsList = allProducts;
	const customCanonicalHref = getMetafield(product, 'custom_canonical_url');
	const productsListCustomerLove = productsCustomerLove?.split('|');

	useEffect(() => {
		// Cuando cambias la visibilidad, simula un evento resize para que Swiper recalcule dimensiones
		window.dispatchEvent(new Event('resize'));
	}, []);

	return (
		<>
			<SEO
				page={page}
				location={location}
				product={product}
				title={product.title}
				pageType='PDP'
				customCanonical={customCanonicalHref}
			/>
			<section id='v1-standard-pdp'>
				<ProductPage
					productsList={productsList ?? []}
					{...{
						product,
						collections,
						cart,
						allBaseColours,
						shadeShotsProducts,
						isPermanentColour,
						rating,
						sellingPlanGroup,
						MiracleSystemSellingPlanGroup,
						productsListCustomerLove,
						allSellingPlanGroups,
					}}
				/>
			</section>
			<section id='v2-standard-pdp' className='hidden-ab'>
				<ProductPage
					productsList={productsList ?? []}
					{...{
						product,
						collections,
						cart,
						allBaseColours,
						shadeShotsProducts,
						isPermanentColour,
						rating,
						sellingPlanGroup,
						MiracleSystemSellingPlanGroup,
						productsListCustomerLove,
						allSellingPlanGroups,
						activeUpdatePdp: true,
					}}
				/>
			</section>
		</>
	);
}

export const query = graphql`
	query ($handle: String!) {
		product: shopifyProduct(handle: { eq: $handle }) {
			...ProductCard
		}
		collections: allShopifyCollection(
			filter: { products: { elemMatch: { handle: { eq: $handle } } } }
		) {
			nodes {
				title
				handle
				products {
					handle
					id
					title
				}
			}
		}
	}
`;
